import React, { useRef, useState, memo, useEffect } from "react";

function CountdownTimer({ currentDate }) {
  const timerIntervalRef = useRef();
  const nowRef = useRef();

  const [timerState, setTimerState] = useState({
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  useEffect(() => {
    if(currentDate) {
      let now = new Date(currentDate);
      now = Date.parse(now) / 1000;
      nowRef.current = now;
    }
  }, [currentDate])

  function makeTimer() {
    let endTime = new Date("09 January 2023 23:59:59 GMT+05:30");

    endTime = Date.parse(endTime) / 1000;

    const now = nowRef.current;

    if (Date.parse(now) <= Date.parse("Sun Jan 08 2023 23:59:59"))
      return clearInterval(timerIntervalRef.current);

    const timeLeft = endTime - now;

    if (timeLeft < 0) return clearInterval(timerIntervalRef.current);

    const days = Math.floor(timeLeft / 86400);
    const hours = Math.floor((timeLeft - days * 86400) / 3600);

    let originalHours = Math.floor(timeLeft / 3600);
    let minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
    let seconds = Math.floor(
      timeLeft - days * 86400 - hours * 3600 - minutes * 60
    );

    if (originalHours < "10") {
      originalHours = `0${originalHours}`;
    }
    if (minutes < "10") {
      minutes = `0${minutes}`;
    }
    if (seconds < "10") {
      seconds = `0${seconds}`;
    }

    setTimerState({
      hours: originalHours,
      minutes,
      seconds,
    });

    nowRef.current += 1;

    return null;
  }

  if (currentDate && !timerIntervalRef.current) {
    timerIntervalRef.current = setInterval(() => {
      makeTimer();
    }, 1000);
  }

  return (
    <div
      className="menu-item-header item header_timer"
    >
      <span className="heading">Sale Ends In</span>
      <span className="time">
        <span>{timerState.hours}</span>
        <span className="timerSeparator">:</span>
        <span>{timerState.minutes}</span>
        <span className="timerSeparator">:</span>
        <span>{timerState.seconds}</span>
      </span>
    </div>
  )
}

export default memo(CountdownTimer);
